import { render, staticRenderFns } from "./PageOverview.vue?vue&type=template&id=e8b657ea&"
import script from "./PageOverview.vue?vue&type=script&lang=js&"
export * from "./PageOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports